export default "__VITE_ASSET__D6yekgbx__"